<template>
  <div class="base-bg" v-if="visible">
    <TopBar :title="$t('edit.settings.setsTitle')" @onClickClose="close" @onClickSave="handleSubmit"></TopBar>
    <div class="set-content">
      <div class="func-cell">
        <span>{{$t('tour.msg.title')}}</span>
        <a-switch
          :checked-children="$t('enum.switch.1')"
          :un-checked-children="$t('enum.switch.0')"
          v-model="form.hidecomment"
          @change="value=>handleChange(value,'hidecomment')"
        />
      </div>

      <div class="func-cell">
        <span>{{$t('descriptions.views')}}</span>
        <a-switch
          :checked-children="$t('enum.switch.1')"
          :un-checked-children="$t('enum.switch.0')"
          v-model="form.hidebrowse"
          @change="value=>handleChange(value,'hidebrowse')"
        />
      </div>

      <div class="func-cell">
        <span>{{$t('common.sceneSelect')}}</span>
        <a-switch
          :checked-children="$t('enum.switch.1')"
          :un-checked-children="$t('enum.switch.0')"
          v-model="form.hidechoose"
          @change="value=>handleChange(!value,'hidechoose')"
        />
      </div>

      <div class="func-cell">
        <span>{{$t('actionTitles.share')}}</span>
        <a-switch
          :checked-children="$t('enum.switch.1')"
          :un-checked-children="$t('enum.switch.0')"
          v-model="form.hideshare"
          @change="value=>handleChange(value,'hideshare')"
        />
      </div>

      <div class="func-cell">
        <span>{{$t('descriptions.music')}}</span>
        <a-switch
          :checked-children="$t('enum.switch.1')"
          :un-checked-children="$t('enum.switch.0')"
          v-model="form.hidebgm"
          @change="value=>handleChange(value,'hidebgm')"
        />
      </div>

      <div class="func-cell">
        <span>{{$t('descriptions.speck')}}</span>
        <a-switch
          :checked-children="$t('enum.switch.1')"
          :un-checked-children="$t('enum.switch.0')"
          v-model="form.hidebgv"
          @change="value=>handleChange(value,'hidebgv')"
        />
      </div>

      <div class="func-cell">
        <span>VR</span>
        <a-switch
          :checked-children="$t('enum.switch.1')"
          :un-checked-children="$t('enum.switch.0')"
          v-model="form.hidevr"
          @change="value=>handleChange(value,'hidevr')"
        />
      </div>

      <div class="func-cell">
        <span>{{$t('edit.settings.fullScreen')}}</span>
        <a-switch
          :checked-children="$t('enum.switch.1')"
          :un-checked-children="$t('enum.switch.0')"
          v-model="form.hidefullscreen"
          @change="value=>handleChange(value,'hidefullscreen')"
        />
      </div>

      <div class="func-cell">
        <span>{{$t('edit.settings.authInfo')}}</span>
        <a-switch
          :checked-children="$t('enum.switch.1')"
          :un-checked-children="$t('enum.switch.0')"
          v-model="form.hideuser"
          @change="value=>handleChange(value,'hideuser')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from "./TopBar.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    TopBar,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        hidechoose: false,
        hidecomment: false,
        hidebrowse: false,
        hideshare: false,
        hidebgm: false,
        hidebgv: false,
        hidevr: false,
        hidefullscreen: false,
        hideuser: false,
      },
    };
  },
  computed: { ...mapGetters(["vrbase"]) },
  created() {
    let setObj = this.$deepClone(this.vrbase.sets);
    let form = {};
    for (let i in setObj) {
      for (let j in this.form) {
        if (i === j) {
          form[i] = !Boolean(setObj[i]);
        }
      }
    }
    this.form = form;
    console.log("FunctionView form =>", this.form);
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleChange(value, option) {
      this.form = Object.assign({}, this.form, { option: !value });
    },
    handleSubmit() {
      let form = {};
      for (let i in this.form) {
        if (this.form[i]) {
          form[i] = 0;
        } else {
          form[i] = 1;
        }
      }
      const vrbase = {
          ...this.vrbase,
          sets: { ...this.vrbase.sets, ...form },
        }
      this.$store
        .dispatch("saveVRBase", { vrbase, showLoading: true,})
        .then(() => {
          this.$emit("close");
        });
    },
  },
};
</script>

<style lang="less" scoped>
.base-bg {
  .set-content {
    .func-cell {
      padding: 15px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid rgba(0,0,0,.08);
      box-shadow: 0 1px 0 0 rgba(255,255,255,.05);
    }
  }
}
</style>